import { FC } from "react";

import { ThankYouEmailCard } from "../../rows/ThankYouEmailCard";
import { AutomatedCommunicationsFormData, RowKey } from "../../types";

interface SimpleRowsProps {
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  defaultValues: AutomatedCommunicationsFormData;
  hasDate: boolean;
  hasLocation: boolean;
  isSweepstakes?: boolean;
}

export const SimpleRows: FC<SimpleRowsProps> = ({
  openRow,
  onToggleOpen,
  defaultValues,
  hasDate,
  hasLocation,
  isSweepstakes = false,
}) => (
  <ThankYouEmailCard
    openRow={openRow}
    onToggleOpen={onToggleOpen}
    defaultContent={defaultValues.thankYouWinner.content}
    hasDate={hasDate}
    hasLocation={hasLocation}
    isSweepstakes={isSweepstakes}
  />
);
